import {createContext} from "react";

export default createContext({
	languagePairs: [],
	loading: false,
	getLanguagePairs: () => {},
	createLanguagePair: () => {},
	removeLanguagePair: () => {},
	editLanguagePair: () => {}
});